<template>
  <div>
    <div class="row" id="plan-header-container">
      <h1>Change Your Authentic.net Plan Anytime</h1>
      <p>The best solution for protecting your brand and gaining trust from your customers, built to scale. Upgrade as you grow.</p>
    </div>
    <div class="row" ref="plans">
      <div class="col-md-4">
        <div class="card plan-card not-featured-plan">
          <div class="card-header">
            <h3 class="card-title">Business Startup 500</h3>
            <p class="category">$49.99 PER MONTH</p>
          </div>
          <button v-if="showActivatePlanBtn(0)" class="btn btn-success btn-fill" @click.prevent="selectPlan(0)">Activate plan</button>
          <button v-if="showCurrentPlanBtn(0)" class="btn btn-default btn-fill" disabled="disabled">Current plan</button>
          <button type="button" v-if="!showActivatePlanBtn(0) && !showCurrentPlanBtn(0)" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Business startup essentials</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 500 Authentic labels per month</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>Amazon.com + 1 additional Retailer / Sales Channel</div></li>
              <li><div>1 User</div></li>
              <li><div>1 Brand</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Ideal for Small Business Startups</div></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card plan-card featured-plan">
          <div class="card-header">
            <h2 class="card-title">Small Business 2000</h2>
            <p class="category">$89.99 PER MONTH</p>
          </div>
          <button v-if="showActivatePlanBtn(1)" class="btn btn-success btn-fill" @click.prevent="selectPlan(1)">Activate plan</button>
          <button v-if="showCurrentPlanBtn(1)" class="btn btn-default btn-fill" disabled="disabled">Current plan</button>
          <button type="button" v-if="!showActivatePlanBtn(1) && !showCurrentPlanBtn(1)" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Flexibility for growth</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 2000 Authentic labels per month</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>All Amazon + 2 additional Retailers / Sales Channels</div></li>
              <li><div>2 Users</div></li>
              <li><div>2 Brands</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Enhanced security &amp; encryption</div></li>
              <li><div>Perfect for the growing Small Business</div></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card plan-card not-featured-plan">
          <div class="card-header">
            <h3 class="card-title">Growing Professional 8000</h3>
            <p class="category">$199 PER MONTH</p>
          </div>
          <button v-if="showActivatePlanBtn(2)" class="btn btn-success btn-fill" @click.prevent="selectPlan(2)">Activate plan</button>
          <button v-if="showCurrentPlanBtn(2)" class="btn btn-default btn-fill" disabled="disabled">Current plan</button>
          <button type="button" v-if="!showActivatePlanBtn(2) && !showCurrentPlanBtn(2)" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Stability at scale</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 8000 Authentic labels per month</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>All Amazon + 4 additional Retailers / Sales Channels</div></li>
              <li><div>4 Users</div></li>
              <li><div>4 Brands</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Enhanced security &amp; encryption</div></li>
              <li><div>Digital Branded Landing Page</div></li>
              <li><div>Digital Registration Warranty Page</div></li>
              <li><div>Perfect for the growing Small Business</div></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row plans-footer">
      <p>Contact us for entrprise level plans and pricing for customized add-ons</p>
      <p v-if="isActive()">Need to cancel your plan? <a href="#" @click.prevent="confirmCancel()">Click here</a>.</p>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import { Card, createToken } from 'vue-stripe-elements-plus'
  import moment from 'moment'
  import { EventBus } from '@/eventBus'
  import swal from 'sweetalert2'

  export default {
    components: { Card },
    mixins: [toolboxMixin],
    props: ['accountData'],
    data () {
      return {
        authDetails: {},
        plans: [
          {
            loading: false,
            id: 'plan_Gopi1jxLyMAsMT',
            name: 'Business Startup 500'
          },
          {
            loading: false,
            id: 'plan_GopjSH0tAGisWr',
            name: 'Small Business 2000'
          },
          {
            loading: false,
            id: 'plan_GoplaPMUji3NvW',
            name: 'Growing Professional 8000'
          }
        ],
        loading: {
          all: true
        }
      }
    },
    methods: {
      async init () {
        this.getAuthDetails().then(authDetails => {
          this.authDetails = authDetails
          this.loading.all = false
        })
      },
      isCurrentPlan (planIndex) {
        return this.plans[planIndex].id === this.authDetails.account.data.stripePlanId
      },
      async selectPlan (planIndex) {
        if (this.authDetails.account.data.status === 'active') {
          console.log('currently active so changing plan', this.authDetails)
          await this.changePlan(planIndex)
        } else {
          console.log('not active so applying new plan', this.authDetails)
          await this.activatePlan(planIndex)
        }
      },
      async activatePlan (planIndex) {
        this.plans[planIndex].loading = true
        let userToken = await firebase.auth().currentUser.getIdToken()
        let data = {
          userToken: userToken,
          stripePlanId: this.plans[planIndex].id,
          planName: this.plans[planIndex].name
        }
        let activatePlan = firebase.functions().httpsCallable('activatePlan')
        activatePlan(data)
        .then(result => {
          this.showNotify('Your plan was changed successfully.', 'success', 'Success')
          this.init()
          EventBus.$emit('auth-refreshed')
          this.plans[planIndex].loading = false
          this.$router.replace({ name: 'Account' })
        })
        .catch(err => {
          swal.fire({
            title: 'Error Changing Plan',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.plans[planIndex].loading = false
        })
      },
      async changePlan (planIndex) {
        this.plans[planIndex].loading = true
        let userToken = await firebase.auth().currentUser.getIdToken()
        let data = {
          userToken: userToken,
          stripePlanId: this.plans[planIndex].id,
          planName: this.plans[planIndex].name
        }
        let changePlan = firebase.functions().httpsCallable('changePlan')
        changePlan(data)
        .then(result => {
          this.showNotify('Your plan was changed successfully.', 'success', 'Success')
          this.init()
          EventBus.$emit('auth-refreshed')
          this.plans[planIndex].loading = false
          this.$router.replace({ name: 'Account' })
        })
        .catch(err => {
          swal.fire({
            title: 'Error Changing Plan',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.plans[planIndex].loading = false
        })
      },
      confirmCancel () {
        swal.fire({
          title: 'Are you sure?',
          text: `Cancelling will leave your brand unprotected.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, I am sure!',
          buttonsStyling: false
        }).then(() => {
          this.cancel()
        })
      },
      async cancel () {
        let userToken = await firebase.auth().currentUser.getIdToken()
        let data = {
          userToken: userToken
        }
        let cancelPlan = firebase.functions().httpsCallable('cancelPlan')
        cancelPlan(data)
        .then(result => {
          this.showNotify('Your plan was cancelled successfully.', 'success', 'Success')
          this.$router.replace({ name: 'Account' })
        })
        .catch(err => {
          swal.fire({
            title: 'Error Cancelling Plan',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        })
      },
      isActive () {
        return !this.loading.all && this.authDetails.account.data.status === 'active'
      },
      showActivatePlanBtn (planIndex) {
        return !this.loading.all && !this.plans[planIndex].loading && (!this.isCurrentPlan(planIndex) || !this.isActive())
      },
      showCurrentPlanBtn (planIndex) {
        return !this.loading.all && !this.plans[planIndex].loading && this.isCurrentPlan(planIndex) && this.isActive()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
#plan-header-container {
  text-align: center;
  padding-bottom: 50px;
}
.plan-card {
  text-align: center;
}
.plan-card .btn {
  width: 80%;
}
.plan-card .no-cc-required {
  color: #9A9A9A;
  display: none;
}
.plan-card .plan-desc {
  border-bottom: 1px solid #dee1e1;
}
.plan-card .plan-desc h6 {
  text-transform: none;
}
.plan-card .plan-inc {
  padding-top: 10px;
  padding-bottom: 10px;
}
.plan-card ul {
  list-style-type: none;
  padding-left: 0;
}
.plan-card ul li div {
  padding-top: 10px;
  padding-bottom: 10px;
}
.plan-card ul li:before {
  display: block;
  width: 50%;
  height: 0;
  margin: .44444rem auto;
  border-top: 1px solid #dee1e1;
  content: "";
}
.featured-plan {
    -webkit-box-shadow: 0 0 28px rgba(22,32,32,.25), 0 10px 10px rgba(22,32,32,.22);
    box-shadow: 0 0 28px rgba(22,32,32,.25), 0 10px 10px rgba(22,32,32,.22);
    padding-top: 3.11111rem;
    padding-bottom: 3.11111rem;
}
.not-featured-plan {
  margin-top: 3.11111rem;
  margin-bottom: 3.11111rem;
}
.plans-footer {
  margin-top: 40px;
  text-align: center;
}
.stripe-card {
  width: 400px;
  margin: 0 auto;
}
.stripe-card base {
  color:lawngreen;
  font-family: inherit !important;
}
.stripe-card.complete {
  border-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChangePlan/ChangePlan.vue